import React from "react";

import styled from "styled-components";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import StepConnector from "@mui/material/StepConnector";

import { DataFormControl } from "../DataFormControl";
import { IDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/IDataDefinition";
import { PropertyEditorBoolean } from "../../../CommonUI/PropertyEditing/PropertyEditorBoolean";
import { PropertyEditorTextList } from "../../../CommonUI/PropertyEditing/PropertyEditorTextList";
import { StringDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";
import { PropertyEditorInteger } from "../../../CommonUI/PropertyEditing/PropertyEditorInteger";
import { PropertyEditorText } from "../../../CommonUI/PropertyEditing/PropertyEditorText";
import { DataUtilities } from "../../../rule-engine-core/Common/DataUtilities";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";
import { PropertyEditorCollapse } from "../../../CommonUI/PropertyEditing/PropertyEditorCollapse";
import { UISpacedBoxContent } from "../../../CommonUI/BuildlingBlocks/UISpacedBoxContent";
import { UILabel } from "../../../CommonUI/BuildlingBlocks/UILabel";

class XTimelineEditUI extends React.Component<{ editMe: TimelineFormControl }> {
    render() {
        return (
            <UISpacedBoxContent>
                {this.props.editMe.renderBaseDataControlEditor()}

                <PropertyEditorBoolean
                    editObject={this.props.editMe}
                    label={"Values from data"}
                    propertyName={"isDynamic"}
                />

                <PropertyEditorBoolean
                    editObject={this.props.editMe}
                    label={"Show vertical"}
                    propertyName={"isVertical"}
                />

                <PropertyEditorCollapse
                    editObject={this.props.editMe}
                    collapseLogicOrField={"isDynamic"}
                >
                    <PropertyEditorText
                        label={"Value Name For Steps"}
                        propertyName={""}
                        editObject={this.props.editMe}
                    />
                </PropertyEditorCollapse>

                <PropertyEditorCollapse
                    editObject={this.props.editMe}
                    collapseLogicOrField={"isDynamic"}
                    showIfFalse={true}
                >
                    <PropertyEditorTextList
                        propertyName={"timelineValues"}
                        editObject={this.props.editMe}
                    />
                </PropertyEditorCollapse>

                <PropertyEditorInteger
                    label={"Label Size"}
                    propertyName={"labelSize"}
                    editObject={this.props.editMe}
                />
            </UISpacedBoxContent>
        );
    }
}

export class TimelineFormControl extends DataFormControl {
    readonly __type: string = "Timeline";
    timelineValues: string[] = [];

    isVertical: boolean = false;

    isDynamic: boolean = false;

    labelSize?: number;

    stepsValueName?: string;

    constructor() {
        super();
        this.canFocus = false;
    }

    render() {
        return (
            <>
                {this.label && <UILabel variant={"form_label"}>{this.label}</UILabel>}
                <div>
                    <Stepper
                        orientation={this.isVertical ? "vertical" : "horizontal"}
                        activeStep={this.getValue()}
                        nonLinear
                        alternativeLabel={!this.isVertical}
                        connector={<StyledTimelineStepConnector />}
                        data-testid={this.valueName}
                    >
                        {this.getStepValues().map((v, index) => (
                            <Step
                                key={index}
                                completed={index <= this.getValue()}
                            >
                                <StyledTimelineItem
                                    isActive={index <= this.getValue()}
                                    color="inherit"
                                    onClick={(e) => this.handleChange(e, index)}
                                    labelsize={this.labelSize}
                                    icon={<StepIcon isActive={index <= this.getValue()} />}
                                >
                                    {v}
                                </StyledTimelineItem>
                            </Step>
                        ))}
                    </Stepper>
                </div>
            </>
        );
    }

    handleChange = (event: any, newValue: number) => {
        if (this.valueName) {
            let newIdx: number = 0;
            newIdx = newValue;
            this.setFormDataValue(this.valueName, this.timelineValues[newIdx]);
        }
    };

    valuetext = (index: number) => {
        return this.getStepValues()[index];
    };

    getStepValues = () => {
        let steps = this.timelineValues;
        if (this.isDynamic && this.stepsValueName) {
            steps = this.getFormDataValue(this.stepsValueName) as string[];
        }
        return steps;
    };

    getValue(): number {
        let steps = this.getStepValues();

        if (this.valueName) {
            let value = this.getFormDataValue(this.valueName);
            return steps.indexOf(value);
        }
        return -1;
    }

    getAddedData(): IDataDefinition | IDataDefinition[] | undefined {
        if (!this.valueName) return;

        let def = new StringDataDefinition();
        def.list = true;
        def.name = this.valueName;
        return def;
    }

    renderEditUI(): JSX.Element | null {
        return <XTimelineEditUI editMe={this} />;
    }

    getStorageData(): object {
        let retData = super.getStorageData();

        retData = DataUtilities.addStorageData(
            this,
            retData,
            "__type",
            "timelineValues",
            "isVertical",
            "isDynamic",
            "labelSize",
            "stepsValueName",
        );

        return retData;
    }

    setStorageData(data: object): void {
        super.setStorageData(data);

        DataUtilities.setStorageData(
            this,
            data,
            "__type",
            "timelineValues",
            "isVertical",
            "isDynamic",
            "labelSize",
            "stepsValueName",
        );
    }
}

const StepIcon = styled.div<{ isActive?: boolean }>`
    width: 24px;
    height: 24px;
    border-radius: 12px;
    background-color: ${(prop) => (prop.isActive ? UIStyleConstants.BLUE_COLOR : UIStyleConstants.GRAY_LIGHTER_COLOR)};
`;

const StyledTimelineItem = styled(StepButton)<{ isActive?: boolean; labelsize?: number }>`
    .MuiStepLabel-label {
        text-align: center;
        padding: 5px 20px;
        border-radius: 4px;
        background: ${(prop) => (prop.isActive ? UIStyleConstants.BLUE_COLOR : UIStyleConstants.GRAY_LIGHTER_COLOR)};
        color: ${UIStyleConstants.WHITE_COLOR} !important;
        position: relative;
        font-size: ${(props) => props.labelsize || 9}px;
    }

    .MuiStepLabel-label.MuiStepLabel-alternativeLabel {
        margin-top: 5px !important;
    }

    .MuiStepLabel-label:before {
        content: "";
        position: absolute;
        bottom: 100%;
        left: -10px;
        top: 50%;
        transform: translate(0px, -50%);
        border: 5px solid transparent;
        border-right-color: ${(prop) =>
            prop.isActive ? UIStyleConstants.BLUE_COLOR : UIStyleConstants.GRAY_LIGHTER_COLOR};
    }

    .MuiStepLabel-label.MuiStepLabel-alternativeLabel:before {
        left: 50%;
        top: -10px;
        transform: translate(-50%, 0px);
        border: 5px solid transparent;
        border-bottom-color: ${(prop) =>
            prop.isActive ? UIStyleConstants.BLUE_COLOR : UIStyleConstants.GRAY_LIGHTER_COLOR};
    }
`;

const StyledTimelineStepConnector = styled(StepConnector)`
    &.MuiStepConnector-alternativeLabel {
        top: 10px;
        left: calc(-50% + 12px);
        right: calc(50% + 12px);
        position: absolute;
    }

    .MuiStepConnector-lineHorizontal {
        border-top-width: 4px;
    }

    &.MuiStepConnector-vertical {
        padding: 0px;
        margin-left: 10px;
    }

    .MuiStepConnector-lineVertical {
        border-left-width: 4px;
    }

    &.MuiStepConnector-active .MuiStepConnector-line {
        border-color: ${UIStyleConstants.BLUE_COLOR};
    }

    &.MuiStepConnector-completed .MuiStepConnector-line {
        border-color: ${UIStyleConstants.BLUE_COLOR};
    }
`;
